import { useCallback, useMemo } from 'react';

import { EDITOR_TYPE } from 'src/data/project';
import * as events from 'src/lib/events';
// @ts-expect-error - useTrackingEvent doesn't have TypeScript definitions
import { useTrackingEvent } from 'src/services/useTrackingEvent';

import { type QuickNavigationEvent } from '../lib';

interface Params {
  inPopupMode?: boolean;
}

export const useEvents = ({ inPopupMode }: Params) => {
  const trackEvent = useTrackingEvent();

  const commonAttributes = useMemo(
    () => ({
      page: events.EVENT_PAGE.homePage,
      uiComponentLocation: inPopupMode ? 'create_content_popup' : 'homepage',
    }),
    [inPopupMode]
  );

  const trackQuickNavigation = useCallback(
    (action: QuickNavigationEvent) => {
      trackEvent(events.CONTENT_CREATION.widgetQuickNavigation, {
        ...commonAttributes,
        actionChosen: action,
      });
    },
    [commonAttributes, trackEvent]
  );

  const trackBlankProject = useCallback(() => {
    trackEvent(events.CONTENT_CREATION.widgetBlankProject, {
      ...commonAttributes,
      contentType: EDITOR_TYPE.shortForm,
    });
  }, [commonAttributes, trackEvent]);

  return useMemo(
    () => ({
      trackQuickNavigation,
      trackBlankProject,
    }),
    [trackQuickNavigation, trackBlankProject]
  );
};
